
const digest = '4b3fc6f20e590495b6a2363bef283f725367e013fb8743aaf470efb164784290';
const classes = {"videoWrapper":"_videoWrapper_11f9w_1","videoWrapperHiding":"_videoWrapperHiding_11f9w_9","videoWrapperShowing":"_videoWrapperShowing_11f9w_14","videoRollDown":"_videoRollDown_11f9w_1","videoWrapperVideo":"_videoWrapperVideo_11f9w_18","videoWrapperPlayButton":"_videoWrapperPlayButton_11f9w_23","videoWrapperPauseButton":"_videoWrapperPauseButton_11f9w_38","playAgainButton":"_playAgainButton_11f9w_63","playIcon":"_playIcon_11f9w_74"};
const css = `._videoWrapper_11f9w_1 {
  position: relative;
  overflow: hidden;
  max-height: 800px;
  opacity: 1;
  transition: max-height 300ms ease, opacity 250ms ease;
}

._videoWrapperHiding_11f9w_9 {
  max-height: 0;
  opacity: 0;
}

._videoWrapperShowing_11f9w_14 {
  animation: _videoRollDown_11f9w_1 300ms ease;
}

._videoWrapperVideo_11f9w_18 {
  width: 100%;
  display: block;
}

._videoWrapperPlayButton_11f9w_23 {
  position: absolute;
  background-image: url("/dist/patientV3/icons/wizard-play-button.svg");
  background-repeat: no-repeat;
  margin: auto;
  cursor: pointer;
  z-index: 1000;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background-size: 300px;
  background-position: center 60%;
}

._videoWrapperPauseButton_11f9w_38 {
  display: none;
  position: absolute;
  background-image: url("/dist/patientV3/icons/pause-sharp-solid.svg");
  background-repeat: no-repeat;
  background-size: cover;
  height: 25px;
  width: 18px;
  margin: auto;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 1000;
}

@keyframes _videoRollDown_11f9w_1 {
  from {
    max-height: 0;
    opacity: 0;
  }
  to {
    max-height: 800px;
    opacity: 1;
  }
}
._playAgainButton_11f9w_63 {
  text-align: center;
  padding: 20px;
  color: #ffffff;
  font-weight: 600;
  background: #000000;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
}
._playAgainButton_11f9w_63 ._playIcon_11f9w_74 {
  height: 85px;
  width: 100px;
  background-image: url("/dist/patientV3/icons/wizard-play-button.svg");
  background-repeat: no-repeat;
  background-size: cover;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  